/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminTokenResponse } from '../models';
// @ts-ignore
import type { AuthBody } from '../models';
// @ts-ignore
import type { AuthReponse } from '../models';
// @ts-ignore
import type { CreateAdminTokenBody } from '../models';
// @ts-ignore
import type { CreateWebHandoffBody } from '../models';
// @ts-ignore
import type { OtpAuthBody } from '../models';
// @ts-ignore
import type { RedeemWebHandoffBody } from '../models';
// @ts-ignore
import type { RefreshBody } from '../models';
// @ts-ignore
import type { RefreshResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { V2AuthReponse } from '../models';
// @ts-ignore
import type { WebHandoffResponse } from '../models';
/**
 * TokenApiApi - axios parameter creator
 */
export const TokenApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * for scripts/API tooling that can\'t hold a browser refresh cookie.
         * @summary Issue the calling admin an access token (up to 24h, admin\'s choice),
         * @param {CreateAdminTokenBody} createAdminTokenBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiCreateAdminToken: async (createAdminTokenBody: CreateAdminTokenBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAdminTokenBody' is not null or undefined
            assertParamExists('tokenApiCreateAdminToken', 'createAdminTokenBody', createAdminTokenBody)
            const localVarPath = `/admin/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdminTokenBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * extension opens Abekus pages through web\'s `/extension/signin` with it, so a browser that isn\'t signed in to Abekus opens them signed in.
         * @summary A one-time code that signs the web app in as the caller. The Chrome
         * @param {CreateWebHandoffBody} createWebHandoffBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiCreateWebHandoff: async (createWebHandoffBody: CreateWebHandoffBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createWebHandoffBody' is not null or undefined
            assertParamExists('tokenApiCreateWebHandoff', 'createWebHandoffBody', createWebHandoffBody)
            const localVarPath = `/v2/auth/handoff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createWebHandoffBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * panel reads it from there to build the `?secondaryToken=` link. It used to also ride a bare `token` cookie (no HttpOnly, Secure, SameSite or Path), which nothing ever read and which parked four hours of full access to someone else\'s account in JS-readable storage on the API origin.
         * @summary Admin impersonation. The token comes back in the body only — the admin
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiGetTokenByUserDetails: async (query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * refresh again, and clear the auth cookies. It must not require a valid token, or an already-expired session couldn\'t log out. `token_version` is reserved for revoke-everything events (password change/reset); it is deliberately not bumped here, since that would log the user out on every other device too.
         * @summary End this device\'s sign-in: revoke its `sid` so no token from it can
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiLogoutUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * set like any other login. The code works once.
         * @summary Trade a handoff code for an access+refresh pair, with the auth cookies
         * @param {RedeemWebHandoffBody} redeemWebHandoffBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiRedeemWebHandoff: async (redeemWebHandoffBody: RedeemWebHandoffBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redeemWebHandoffBody' is not null or undefined
            assertParamExists('tokenApiRedeemWebHandoff', 'redeemWebHandoffBody', redeemWebHandoffBody)
            const localVarPath = `/v2/auth/handoff/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemWebHandoffBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * an HttpOnly cookie. The frontend axios interceptor handles expiry by posting to `/v2/token/refresh`.
         * @summary v2 login (web). Access+refresh pair in body; refresh token also set as
         * @param {AuthBody} authBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiV2Auth: async (authBody: AuthBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authBody' is not null or undefined
            assertParamExists('tokenApiV2Auth', 'authBody', authBody)
            const localVarPath = `/v2/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary v2 OTP login — fallback for users who fail password authentication.
         * @param {OtpAuthBody} otpAuthBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiV2AuthOtp: async (otpAuthBody: OtpAuthBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otpAuthBody' is not null or undefined
            assertParamExists('tokenApiV2AuthOtp', 'otpAuthBody', otpAuthBody)
            const localVarPath = `/v2/auth/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpAuthBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * via the HttpOnly cookie; mobile (future v2) via the request body.
         * @summary Exchange a refresh token for a new access+refresh pair. Web sends it
         * @param {RefreshBody} refreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiV2Refresh: async (refreshBody: RefreshBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshBody' is not null or undefined
            assertParamExists('tokenApiV2Refresh', 'refreshBody', refreshBody)
            const localVarPath = `/v2/token/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApiApi - functional programming interface
 */
export const TokenApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiApiAxiosParamCreator(configuration)
    return {
        /**
         * for scripts/API tooling that can\'t hold a browser refresh cookie.
         * @summary Issue the calling admin an access token (up to 24h, admin\'s choice),
         * @param {CreateAdminTokenBody} createAdminTokenBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenApiCreateAdminToken(createAdminTokenBody: CreateAdminTokenBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenApiCreateAdminToken(createAdminTokenBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApiApi.tokenApiCreateAdminToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * extension opens Abekus pages through web\'s `/extension/signin` with it, so a browser that isn\'t signed in to Abekus opens them signed in.
         * @summary A one-time code that signs the web app in as the caller. The Chrome
         * @param {CreateWebHandoffBody} createWebHandoffBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenApiCreateWebHandoff(createWebHandoffBody: CreateWebHandoffBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebHandoffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenApiCreateWebHandoff(createWebHandoffBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApiApi.tokenApiCreateWebHandoff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * panel reads it from there to build the `?secondaryToken=` link. It used to also ride a bare `token` cookie (no HttpOnly, Secure, SameSite or Path), which nothing ever read and which parked four hours of full access to someone else\'s account in JS-readable storage on the API origin.
         * @summary Admin impersonation. The token comes back in the body only — the admin
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenApiGetTokenByUserDetails(query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthReponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenApiGetTokenByUserDetails(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApiApi.tokenApiGetTokenByUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * refresh again, and clear the auth cookies. It must not require a valid token, or an already-expired session couldn\'t log out. `token_version` is reserved for revoke-everything events (password change/reset); it is deliberately not bumped here, since that would log the user out on every other device too.
         * @summary End this device\'s sign-in: revoke its `sid` so no token from it can
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenApiLogoutUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenApiLogoutUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApiApi.tokenApiLogoutUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * set like any other login. The code works once.
         * @summary Trade a handoff code for an access+refresh pair, with the auth cookies
         * @param {RedeemWebHandoffBody} redeemWebHandoffBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenApiRedeemWebHandoff(redeemWebHandoffBody: RedeemWebHandoffBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2AuthReponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenApiRedeemWebHandoff(redeemWebHandoffBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApiApi.tokenApiRedeemWebHandoff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * an HttpOnly cookie. The frontend axios interceptor handles expiry by posting to `/v2/token/refresh`.
         * @summary v2 login (web). Access+refresh pair in body; refresh token also set as
         * @param {AuthBody} authBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenApiV2Auth(authBody: AuthBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2AuthReponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenApiV2Auth(authBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApiApi.tokenApiV2Auth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary v2 OTP login — fallback for users who fail password authentication.
         * @param {OtpAuthBody} otpAuthBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenApiV2AuthOtp(otpAuthBody: OtpAuthBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V2AuthReponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenApiV2AuthOtp(otpAuthBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApiApi.tokenApiV2AuthOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * via the HttpOnly cookie; mobile (future v2) via the request body.
         * @summary Exchange a refresh token for a new access+refresh pair. Web sends it
         * @param {RefreshBody} refreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenApiV2Refresh(refreshBody: RefreshBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefreshResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenApiV2Refresh(refreshBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApiApi.tokenApiV2Refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TokenApiApi - factory interface
 */
export const TokenApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiApiFp(configuration)
    return {
        /**
         * for scripts/API tooling that can\'t hold a browser refresh cookie.
         * @summary Issue the calling admin an access token (up to 24h, admin\'s choice),
         * @param {TokenApiApiTokenApiCreateAdminTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiCreateAdminToken(requestParameters: TokenApiApiTokenApiCreateAdminTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTokenResponse> {
            return localVarFp.tokenApiCreateAdminToken(requestParameters.createAdminTokenBody, options).then((request) => request(axios, basePath));
        },
        /**
         * extension opens Abekus pages through web\'s `/extension/signin` with it, so a browser that isn\'t signed in to Abekus opens them signed in.
         * @summary A one-time code that signs the web app in as the caller. The Chrome
         * @param {TokenApiApiTokenApiCreateWebHandoffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiCreateWebHandoff(requestParameters: TokenApiApiTokenApiCreateWebHandoffRequest, options?: RawAxiosRequestConfig): AxiosPromise<WebHandoffResponse> {
            return localVarFp.tokenApiCreateWebHandoff(requestParameters.createWebHandoffBody, options).then((request) => request(axios, basePath));
        },
        /**
         * panel reads it from there to build the `?secondaryToken=` link. It used to also ride a bare `token` cookie (no HttpOnly, Secure, SameSite or Path), which nothing ever read and which parked four hours of full access to someone else\'s account in JS-readable storage on the API origin.
         * @summary Admin impersonation. The token comes back in the body only — the admin
         * @param {TokenApiApiTokenApiGetTokenByUserDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiGetTokenByUserDetails(requestParameters: TokenApiApiTokenApiGetTokenByUserDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuthReponse> {
            return localVarFp.tokenApiGetTokenByUserDetails(requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * refresh again, and clear the auth cookies. It must not require a valid token, or an already-expired session couldn\'t log out. `token_version` is reserved for revoke-everything events (password change/reset); it is deliberately not bumped here, since that would log the user out on every other device too.
         * @summary End this device\'s sign-in: revoke its `sid` so no token from it can
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiLogoutUser(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.tokenApiLogoutUser(options).then((request) => request(axios, basePath));
        },
        /**
         * set like any other login. The code works once.
         * @summary Trade a handoff code for an access+refresh pair, with the auth cookies
         * @param {TokenApiApiTokenApiRedeemWebHandoffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiRedeemWebHandoff(requestParameters: TokenApiApiTokenApiRedeemWebHandoffRequest, options?: RawAxiosRequestConfig): AxiosPromise<V2AuthReponse> {
            return localVarFp.tokenApiRedeemWebHandoff(requestParameters.redeemWebHandoffBody, options).then((request) => request(axios, basePath));
        },
        /**
         * an HttpOnly cookie. The frontend axios interceptor handles expiry by posting to `/v2/token/refresh`.
         * @summary v2 login (web). Access+refresh pair in body; refresh token also set as
         * @param {TokenApiApiTokenApiV2AuthRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiV2Auth(requestParameters: TokenApiApiTokenApiV2AuthRequest, options?: RawAxiosRequestConfig): AxiosPromise<V2AuthReponse> {
            return localVarFp.tokenApiV2Auth(requestParameters.authBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary v2 OTP login — fallback for users who fail password authentication.
         * @param {TokenApiApiTokenApiV2AuthOtpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiV2AuthOtp(requestParameters: TokenApiApiTokenApiV2AuthOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<V2AuthReponse> {
            return localVarFp.tokenApiV2AuthOtp(requestParameters.otpAuthBody, options).then((request) => request(axios, basePath));
        },
        /**
         * via the HttpOnly cookie; mobile (future v2) via the request body.
         * @summary Exchange a refresh token for a new access+refresh pair. Web sends it
         * @param {TokenApiApiTokenApiV2RefreshRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenApiV2Refresh(requestParameters: TokenApiApiTokenApiV2RefreshRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefreshResponse> {
            return localVarFp.tokenApiV2Refresh(requestParameters.refreshBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for tokenApiCreateAdminToken operation in TokenApiApi.
 */
export interface TokenApiApiTokenApiCreateAdminTokenRequest {
    readonly createAdminTokenBody: CreateAdminTokenBody
}

/**
 * Request parameters for tokenApiCreateWebHandoff operation in TokenApiApi.
 */
export interface TokenApiApiTokenApiCreateWebHandoffRequest {
    readonly createWebHandoffBody: CreateWebHandoffBody
}

/**
 * Request parameters for tokenApiGetTokenByUserDetails operation in TokenApiApi.
 */
export interface TokenApiApiTokenApiGetTokenByUserDetailsRequest {
    readonly query?: string
}

/**
 * Request parameters for tokenApiRedeemWebHandoff operation in TokenApiApi.
 */
export interface TokenApiApiTokenApiRedeemWebHandoffRequest {
    readonly redeemWebHandoffBody: RedeemWebHandoffBody
}

/**
 * Request parameters for tokenApiV2Auth operation in TokenApiApi.
 */
export interface TokenApiApiTokenApiV2AuthRequest {
    readonly authBody: AuthBody
}

/**
 * Request parameters for tokenApiV2AuthOtp operation in TokenApiApi.
 */
export interface TokenApiApiTokenApiV2AuthOtpRequest {
    readonly otpAuthBody: OtpAuthBody
}

/**
 * Request parameters for tokenApiV2Refresh operation in TokenApiApi.
 */
export interface TokenApiApiTokenApiV2RefreshRequest {
    readonly refreshBody: RefreshBody
}

/**
 * TokenApiApi - object-oriented interface
 */
export class TokenApiApi extends BaseAPI {
    /**
     * for scripts/API tooling that can\'t hold a browser refresh cookie.
     * @summary Issue the calling admin an access token (up to 24h, admin\'s choice),
     * @param {TokenApiApiTokenApiCreateAdminTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenApiCreateAdminToken(requestParameters: TokenApiApiTokenApiCreateAdminTokenRequest, options?: RawAxiosRequestConfig) {
        return TokenApiApiFp(this.configuration).tokenApiCreateAdminToken(requestParameters.createAdminTokenBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * extension opens Abekus pages through web\'s `/extension/signin` with it, so a browser that isn\'t signed in to Abekus opens them signed in.
     * @summary A one-time code that signs the web app in as the caller. The Chrome
     * @param {TokenApiApiTokenApiCreateWebHandoffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenApiCreateWebHandoff(requestParameters: TokenApiApiTokenApiCreateWebHandoffRequest, options?: RawAxiosRequestConfig) {
        return TokenApiApiFp(this.configuration).tokenApiCreateWebHandoff(requestParameters.createWebHandoffBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * panel reads it from there to build the `?secondaryToken=` link. It used to also ride a bare `token` cookie (no HttpOnly, Secure, SameSite or Path), which nothing ever read and which parked four hours of full access to someone else\'s account in JS-readable storage on the API origin.
     * @summary Admin impersonation. The token comes back in the body only — the admin
     * @param {TokenApiApiTokenApiGetTokenByUserDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenApiGetTokenByUserDetails(requestParameters: TokenApiApiTokenApiGetTokenByUserDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return TokenApiApiFp(this.configuration).tokenApiGetTokenByUserDetails(requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * refresh again, and clear the auth cookies. It must not require a valid token, or an already-expired session couldn\'t log out. `token_version` is reserved for revoke-everything events (password change/reset); it is deliberately not bumped here, since that would log the user out on every other device too.
     * @summary End this device\'s sign-in: revoke its `sid` so no token from it can
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenApiLogoutUser(options?: RawAxiosRequestConfig) {
        return TokenApiApiFp(this.configuration).tokenApiLogoutUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * set like any other login. The code works once.
     * @summary Trade a handoff code for an access+refresh pair, with the auth cookies
     * @param {TokenApiApiTokenApiRedeemWebHandoffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenApiRedeemWebHandoff(requestParameters: TokenApiApiTokenApiRedeemWebHandoffRequest, options?: RawAxiosRequestConfig) {
        return TokenApiApiFp(this.configuration).tokenApiRedeemWebHandoff(requestParameters.redeemWebHandoffBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * an HttpOnly cookie. The frontend axios interceptor handles expiry by posting to `/v2/token/refresh`.
     * @summary v2 login (web). Access+refresh pair in body; refresh token also set as
     * @param {TokenApiApiTokenApiV2AuthRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenApiV2Auth(requestParameters: TokenApiApiTokenApiV2AuthRequest, options?: RawAxiosRequestConfig) {
        return TokenApiApiFp(this.configuration).tokenApiV2Auth(requestParameters.authBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary v2 OTP login — fallback for users who fail password authentication.
     * @param {TokenApiApiTokenApiV2AuthOtpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenApiV2AuthOtp(requestParameters: TokenApiApiTokenApiV2AuthOtpRequest, options?: RawAxiosRequestConfig) {
        return TokenApiApiFp(this.configuration).tokenApiV2AuthOtp(requestParameters.otpAuthBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * via the HttpOnly cookie; mobile (future v2) via the request body.
     * @summary Exchange a refresh token for a new access+refresh pair. Web sends it
     * @param {TokenApiApiTokenApiV2RefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tokenApiV2Refresh(requestParameters: TokenApiApiTokenApiV2RefreshRequest, options?: RawAxiosRequestConfig) {
        return TokenApiApiFp(this.configuration).tokenApiV2Refresh(requestParameters.refreshBody, options).then((request) => request(this.axios, this.basePath));
    }
}

